import { cn } from '@/lib/utils';
import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface CTAButtonProps {
  label?: string;
  className?: string;
  href?: string;
  variant?: 'gold' | 'dark';
  showArrow?: boolean;
}

/** Checkout oficial y único de Wellness Digital PRO. */
export const CHECKOUT_URL = 'https://wellness-digital-pro.impultienda.ar/checkout';
export function CTAButton({
  label = '🌿 QUIERO QUE MI INSTAGRAM CONVIERTA',
  className = '',
  href = CHECKOUT_URL,
  variant = 'gold',
  showArrow = true
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith(CHECKOUT_URL);
  const handleClick = () => {
    if (goesToCheckout) trackInitiateCheckout();
  };
  const palette = variant === 'dark' ? 'bg-charcoal text-ivory ring-1 ring-charcoal hover:bg-charcoal-soft focus-visible:ring-gold/60' : 'bg-gold text-charcoal ring-1 ring-gold-deep/40 hover:bg-gold-deep hover:text-ivory focus-visible:ring-gold/50';
  return <a href={href} onClick={handleClick} className={cn('group inline-flex min-h-[54px] items-center justify-center gap-2 rounded-full px-7 py-3.5 text-center font-sans text-[0.78rem] font-bold uppercase leading-tight tracking-[0.12em] shadow-[0_10px_30px_-12px_rgba(28,27,25,0.45)] transition-all hover:-translate-y-0.5 hover:shadow-[0_16px_36px_-14px_rgba(28,27,25,0.5)] focus:outline-none focus-visible:ring-4 sm:text-sm', palette, className)} data-id="element-43" data-mp="199y6m8w8pp13">
      {label}
      {showArrow && <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform group-hover:translate-x-1" aria-hidden data-id="element-44" data-mp="1w79gf31uo9ib" />}
    </a>;
}